import { useContext } from 'react';
import { HostContext } from 'src/core/contexts/host';
export function useHostContext() {
    const context = useContext(HostContext);
    if (!context) {
        throw new Error('useHostContext must be used within a HostProvider');
    }
    return context;
}
